import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";
import * as Yup from "yup";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import profileImg from "../../assets/images/profile-img.png";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { editProfile, resetProfileFlag } from "slices/thunk";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import Select from "react-select";
import MainMap from "Components/MainMap/Index";
import { register } from "module";

const optionGroup = [
  { label: "Усны мэргэжлийн байгууллагын үйл ажиллагаа эрхлэх", value: "1" },
  { label: "Зөвшөөрөл 2", value: "2" },
  { label: "Зөвшөөрөл 3", value: "3" }
];

const optionGroup2 = [
  { label: "Усны хайгуул, судалгаа явуулах", value: "1" },
  { label: "Усны барилга, байгууламжийн зураг төсөл боловсруулах", value: "2" },
  { label: "Цооног өрөмдөх, тоноглох, сэргээн засварлах", value: "3" },
  { label: "Усны барилга, байгууламж барих, сэргээн засварлах, шинэчлэх", value: "4" },
  { label: "Усны аудит хийх", value: "5" },
];

const bankOption = [
  { label: "Хаан банк", value: "1" },
  { label: "ХХБ", value: "2" },
  { label: "Төрийн банк", value: "3", selected: true },
  { label: "Хас банк", value: "4" },
  { label: "Капитрон банк", value: "5" },
  { label: "Тээвэр хөгжлийн банк", value: "6" },
  { label: "Ариг банк", value: "7" },
  { label: "Чингис хаан банк", value: "8" },
  { label: "Төрийн сан", value: "9" },
];

const OrganizationProfile = (props: any) => {


  const [baseMap, setBaseMap] = useState("voyager")
  const [results, setResults] = useState([] as any)

  const [selectedMulti, setselectedMulti] = useState(null) as any[];
  const [processingTypeSelect, setProcessingTypeSelect] = useState(null) as any[];
  const [bankNameSelect, setBankNameSelect] = useState(bankOption[2]) as any[];
  const [orgDetailInfo, setOrgDetailInfo] = useState('') as any[];

  function handleMulti(selectedMulti: any) {
    setselectedMulti(selectedMulti);
  }
  function handleMulti2(processingTypeSelect: any) {
    setProcessingTypeSelect(processingTypeSelect);
  }

  function handleMulti3(bankNameSelect: any) {
    setBankNameSelect(bankNameSelect);
  }

  useEffect(() => {
    setOrgDetailInfo(props.personInfo)
  }, [props.personInfo]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      fname: orgDetailInfo?.legalEntity?.fname,
      register: orgDetailInfo?.legalEntity?.register,
      establishedYear: orgDetailInfo?.legalEntity?.establishedYear,
      phono_no: orgDetailInfo?.phono_no,
      address: orgDetailInfo?.address,
      email: orgDetailInfo?.email,
      staffCount: orgDetailInfo?.staffCount,
      siteUrl: orgDetailInfo?.siteUrl,
      

      lname: orgDetailInfo?.lname,
    },
    validationSchema: Yup.object({
      fname: Yup.string().required("Текст утга оруулна уу !"),
      register: Yup.string().required("Текст утга оруулна уу !"),
      establishedYear: Yup.string().required("Байгуулагдсан он оруулна уу !"),
      phono_no: Yup.string().required("Утасны дугаар оруулна уу !"),
      address: Yup.string().required("Хаяг оруулна уу !"),
      email: Yup.string().required("Цахим шуудан оруулна уу !"),
      staffCount: Yup.string().required("Ажилчдын тоо оруулна уу !"),
      siteUrl: Yup.string().required("Албан ёсны веб сайтын link оруулна уу !"),
    }),
    onSubmit: (values) => {
      console.log(typeof validation.errors.establishedYear === 'string');

      // dispatch(editProfile(values));
    },
  });


  console.log(validation.touched.establishedYear && validation.errors.establishedYear);

  // console.log(validation);
  console.log("Touched:", validation.touched);
  console.log("Errors:", validation.errors);


  return (
    <React.Fragment>
      <Row>
        <Col lg={4}>
          <Card className="overflow-hidden">
            <div className="bg-primary-subtle">
              <Row>
                <Col xs={7}>
                  <div className="text-primary p-3">
                    <h5 className="text-primary">Welcome Back ! </h5>
                  </div>
                </Col>
                <Col xs={5} className="align-self-end">
                  <img src={orgDetailInfo?.profile === null ? profileImg : orgDetailInfo?.profile} alt="" className="img-fluid" />
                </Col>
              </Row>
            </div>
            <CardBody className="">
              <Row>
                <Col sm={6}>
                  {/* <div className="avatar-xl profile-user-wid mb-4">
                    <img
                      src={avatar1}
                      alt=""
                      className="img-thumbnail rounded-circle"
                    />
                  </div> */}
                  <h5 className="font-size-15 text-truncate fw-semibold">
                    {orgDetailInfo?.legalEntity?.fname}
                  </h5>
                  <p className="text-muted mb-0 text-truncate">
                    ID: {orgDetailInfo?.legalEntity?.register}
                  </p>
                </Col>

                <Col sm={6}>
                  <div className="pt-4">
                    {/* <Row>
                      <Col xs={6}>
                        <h5 className="font-size-15">125</h5>
                        <p className="text-muted mb-0">Projects</p>
                      </Col>
                      <Col xs={6}>
                        <h5 className="font-size-15">$1245</h5>
                        <p className="text-muted mb-0">Revenue</p>
                      </Col>
                    </Row> */}
                    {/* <div className="mt-4">
                      <Link to="#" className="btn btn-primary  btn-sm">
                        View Profile{" "}
                        <i className="mdi mdi-arrow-right ms-1"></i>
                      </Link>
                    </div> */}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg={6}>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Компани нэр</Label>
                      <Input
                        name="fname"
                        className="form-control"
                        disabled
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.fname || ""}
                        invalid={
                          validation.touched.fname && validation.errors.fname
                            ? true
                            : false
                        }
                      />
                      {validation.touched.fname && typeof validation.errors.fname === 'string' ? (
                        <FormFeedback type="invalid">
                          {validation.errors.fname}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Байгуулагдсан он</Label>
                      <Input
                        name="establishedYear"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.establishedYear}
                        invalid={
                          validation.touched.establishedYear && validation.errors.establishedYear ? true : false
                        }
                      />
                      {validation.touched.establishedYear === true && typeof validation.errors.establishedYear === 'string' ? (
                        <FormFeedback type="invalid">
                          {validation.errors.establishedYear}
                        </FormFeedback>
                      ) : null}

                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Утас</Label>
                      <Input
                        name="phono_no"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.phono_no}
                        invalid={
                          validation.touched.phono_no && validation.errors.phono_no
                            ? true
                            : false
                        }
                      />
                      {validation.touched.phono_no === true && typeof validation.errors.phono_no === 'string' ? (
                        <FormFeedback type="invalid">
                          {validation.errors.phono_no}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Хаяг</Label>
                      <Input
                        name="address"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.address || ""}
                        invalid={
                          validation.touched.address && validation.errors.address
                            ? true
                            : false
                        }
                      />
                      {validation.touched.address === true && typeof validation.errors.address === 'string' ? (
                        <FormFeedback type="invalid">
                          {validation.errors.address}
                        </FormFeedback>
                      ) : null}

                    </div>
                    <div className="form-group mb-3">

                      <Label className="form-label fw-semibold">Сошиал хуудас</Label>
                      <div className="input-group mb-3">
                        <Input
                          name="lname"
                          className="form-control"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          // value={validation.values.lname || "Сандаг"}
                          value={"https://www.facebook.com/profile.php?id=100071016612048"}
                          invalid={
                            validation.touched.lname && validation.initialValues.lname
                              ? true
                              : false
                          }
                        />
                        <button
                          type="button"
                          className="btn btn-primary  btn-label"
                        >
                          <i className="mdi mdi-facebook label-icon"></i>
                          <a href="https://www.facebook.com/profile.php?id=100071016612048" target="__blank" className="text-white">
                            Шалгах
                          </a>
                        </button>

                      </div>

                      <div className="input-group mb-3">
                        <Input
                          name="lname"
                          className="form-control"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          // value={validation.values.lname || "Сандаг"}
                          value={"https://www.instagram.com/"}
                          invalid={
                            validation.touched.lname && validation.initialValues.lname
                              ? true
                              : false
                          }
                        />
                        <button
                          type="button"
                          style={{ backgroundColor: '#C13584', border: '1px solid #C13584' }}
                          className="btn btn-primary  btn-label"
                        >
                          <i className="mdi mdi-instagram label-icon"></i>
                          <a href="https://www.instagram.com/" target="__blank" className="text-white">
                            Шалгах
                          </a>
                        </button>

                      </div>

                      <div className="input-group mb-3">
                        <Input
                          name="lname"
                          className="form-control"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          // value={validation.values.lname || "Сандаг"}
                          value={"https://www.youtube.com/"}
                          invalid={
                            validation.touched.lname && validation.initialValues.lname
                              ? true
                              : false
                          }
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-label"
                        >
                          <i className="mdi mdi-youtube label-icon"></i>
                          <a href="https://www.youtube.com/" target="__blank" className="text-white">
                            Шалгах
                          </a>
                        </button>

                      </div>

                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Банкны нэр</Label>
                      <Select
                        value={bankNameSelect}
                        isMulti={false}
                        onChange={(selectedOption) => {
                          handleMulti3(selectedOption);
                        }}
                        options={bankOption}
                        className="select2-selection"
                      />
                    </div>

                  </Col>
                  <Col lg={6}>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Байгууллагын регистер</Label>
                      <Input
                        name="register"
                        className="form-control"
                        disabled
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.register || ""}
                        invalid={
                          validation.touched.register && validation.errors.register
                            ? true
                            : false
                        }
                      />
              {validation.touched.register === true && typeof validation.errors.register === 'string' ? (
                        <FormFeedback type="invalid">
                          {validation.errors.register}
                        </FormFeedback>
                      ) : null}

                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Ажилчидын тоо</Label>
                      <Input
                        name="staffCount"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.staffCount || ""}
                        invalid={
                          validation.touched.staffCount && validation.errors.staffCount
                            ? true
                            : false
                        }
                      />
                         {validation.touched.staffCount === true && typeof validation.errors.staffCount === 'string' ? (
                        <FormFeedback type="invalid">
                          {validation.errors.staffCount}
                        </FormFeedback>
                      ) : null}

                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Цахим шуудан</Label>
                      <Input
                        name="email"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                            ? true
                            : false
                        }
                      />
                         {validation.touched.email === true && typeof validation.errors.email === 'string' ? (
                        <FormFeedback type="invalid">
                          {validation.errors.email}
                        </FormFeedback>
                      ) : null}

                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Веб сайт</Label>
                      <div className="input-group">
                        <Input
                          name="siteUrl"
                          className="form-control"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.siteUrl}
                          invalid={
                            validation.touched.siteUrl && validation.errors.siteUrl
                              ? true
                              : false
                          }
                        />
                        <button
                          type="button"
                          className="btn btn-primary  btn-label"
                        >
                          <i className="mdi mdi-link-variant label-icon"></i>
                          <a href="https://www.erkhet-innovation.com" target="__blank" className="text-white">
                            Шалгах
                          </a>
                        </button>
                      {validation.touched.siteUrl === true && typeof validation.errors.siteUrl === 'string' ? (
                        <FormFeedback type="invalid">
                          {validation.errors.siteUrl}
                        </FormFeedback>
                      ) : null}
                      </div>

                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Тусгай зөвшөөрөл</Label>
                      <Select
                        value={selectedMulti}
                        isMulti={true}
                        onChange={(selectedOption) => {
                          handleMulti(selectedOption);
                        }}
                        options={optionGroup}
                        className="select2-selection"
                      />
                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Үйл ажиллагааны төрөл</Label>
                      <Select
                        value={processingTypeSelect}
                        isMulti={true}
                        onChange={(selectedOption) => {
                          handleMulti2(selectedOption);
                        }}
                        options={optionGroup2}
                        className="select2-selection"
                      />
                    </div>
                    <div className="form-group mb-3">
                      <Label className="form-label fw-semibold">Дансны дугаар</Label>
                      <Input
                        name="lname"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        // value={validation.values.lname || "Сандаг"}
                        value={"34551615444"}
                        invalid={
                          validation.touched.lname && validation.initialValues.lname
                            ? true
                            : false
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    {/* <MainMap results={results} baseMap={baseMap} /> */}
                  </Col>
                </Row>
                <div className="text-center mt-4">
                  <Button type="submit" color="primary">
                    Мэдээлэл засах
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default OrganizationProfile;